export type CopyServiceHealthSlot = {
  time: string;
  enabled: boolean;
  positive_enabled: boolean;
};

export type CopyServiceHealthCheck = {
  trigger: "manual" | "scheduled";
  slot_time: string | null;
};

export function updateCopyServiceHealthSlot<T extends CopyServiceHealthSlot>(
  slots: T[],
  slotIndex: number,
  patch: { enabled?: boolean; positiveEnabled?: boolean },
): T[] {
  return slots.map((slot, index) => {
    if (index !== slotIndex) return slot;
    const enabled = patch.enabled ?? slot.enabled;
    const positiveEnabled = enabled
      ? (patch.positiveEnabled ?? (slot.positive_enabled === true))
      : false;
    return {
      ...slot,
      enabled,
      positive_enabled: positiveEnabled,
    };
  });
}

export function copyServiceHealthSchedulePayload(slots: CopyServiceHealthSlot[]) {
  return slots.map(({ time, enabled, positive_enabled }) => ({
    time,
    enabled,
    positive_enabled: enabled && positive_enabled === true,
  }));
}

export function scheduledCopyServiceChecks<T extends CopyServiceHealthCheck>(
  checks: T[],
  slotTime: string,
): T[] {
  return checks.filter((check) => check.trigger === "scheduled" && check.slot_time === slotTime);
}

export function manualCopyServiceChecks<T extends CopyServiceHealthCheck>(checks: T[]): T[] {
  return checks.filter((check) => check.trigger === "manual" && check.slot_time === null);
}
